import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import {
  CreateProviderRow,
  ProviderRow,
  ProviderSearchResult,
  UpdateProviderRow,
} from "./provider.type";

export const searchProvidersApi = async (params: {
  q: string;
  limit?: number;
  cursor?: number;
}): Promise<ProviderSearchResult> => {
  const { q, limit = 20, cursor = 0 } = params;
  const queryParams = new URLSearchParams({
    q,
    limit: String(limit),
    cursor: String(cursor),
  });

  const slug = `${ApiEndpoints.provider}/search?${queryParams.toString()}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<ProviderSearchResult>(slug, options);
};

export const getProvider = async (providerId: string): Promise<ProviderRow> => {
  const slug = ApiEndpoints.provider + `/${providerId}`;

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<ProviderRow>(slug, options);
};

export const updateProvider = async (
  provider: UpdateProviderRow
): Promise<ProviderRow> => {
  const slug = ApiEndpoints.provider + "/";

  const options = await setHeaderOptions({ method: "PUT", body: provider });

  return fetchData<ProviderRow>(slug, options);
};

export const createProvider = async (
  provider: CreateProviderRow
): Promise<ProviderRow> => {
  const slug = ApiEndpoints.provider + "/";

  const options = await setHeaderOptions({ method: "POST", body: provider });

  return fetchData<ProviderRow>(slug, options);
};

// AI-assisted contact lookup by provider name
// POST /provider/lookup { name: string }
export const lookupProviderByName = async (name: string): Promise<any> => {
  const slug = `${ApiEndpoints.provider}/lookup`;
  const options = await setHeaderOptions({ method: "POST", body: { name } });
  return fetchData<any>(slug, options);
};

export const lookupProviderFax = async ({
  providerId,
  institutionId,
}: {
  providerId?: string;
  institutionId?: string;
}): Promise<{ fax: string | null }> => {
  const slug = `${ApiEndpoints.provider}/lookup-fax`;
  const options = await setHeaderOptions({
    method: "POST",
    body: { providerId, institutionId },
  });

  return fetchData<{ fax: string | null }>(slug, options);
};
